import { IVehicleMaintenanceType } from './vehicle.maintenance.type';

export enum VehicleMaintenanceStatus {
  SCHEDULED = 'SCHEDULED',
  COMPLETED = 'COMPLETED',
}
export interface IVehicleMaintenance {
  _id?: string;
  vehicle: string;
  agency: string;
  date: Date | string;
  expirationDate?: Date | string | null;
  maintenanceType: string | IVehicleMaintenanceType;
  customMaintenanceType?: string | null;
  description: string;
  repairedBy?: string | null;
  cost?: number | null;
  status: VehicleMaintenanceStatus;
  createdAt?: Date | string;
  updatedAt?: Date | string;
  deleted?: boolean;
}
